/**
 * This file exports package metadata
 * It's separated to make it easier to handle in build processes
 * and to centralize package information access.
 */

// TODO: When this becomes a library, move this information to package.json
// and update this file to import from there. This avoids import issues during development.
export const packageInfo = {
    name: '@honeybook/ai-core',
    version: '1.9.3'
};
